import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalController } from '@ionic/angular';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { IDialogComponent, IDialogPresenter } from './interfaces';
import { I18nService } from '@core/services';
import { ComponentEnum } from '@core/enums';
import { selectLanguaje } from '@store/selectors';
import { takeUntil } from 'rxjs';
import { 
  DialogTypeEnumValues, DialogTypeEnum,
  DialogTitleTypeEnum, DialogTitleTypeEnumValues,
  DialogTitleAlignEnumValues, DialogTitleAlignEnum
} from './enums';

@Injectable()
export class DialogPresenter
  extends IAbstractPresenter<IDialogComponent>
  implements IDialogPresenter
{
  title: string | null = null;
  type: DialogTypeEnumValues = DialogTypeEnum.COMMON_SHORT;
  showTitle: boolean = false;
  showFooter: boolean = false;
  showConfirm: boolean = false;
  showCancel: boolean = false;
  showThird: boolean = false;
  showCloseIcon: boolean = true;
  isStandaloneOverlay: boolean = false;
  showBottomBar: boolean = true;
  confirmText?: string;
  cancelText?: string;
  thirdText?: string;
  confirmDisabled: boolean = false;
  titleAlign: DialogTitleAlignEnumValues = DialogTitleAlignEnum.LEFT;
  titleType: DialogTitleTypeEnumValues = DialogTitleTypeEnum.NEUTRAL;

  translations: ILanguageObject;

  constructor(
    private store: Store, 
    private i18nService: I18nService,
    private modalCtrl: ModalController
  ) {
    super();
    this.translations = this.i18nService.getTranslations(ComponentEnum.Dialog);
  }

  dispatchActions(): void {}

  suscribeObservers(): void {
    this.store
      .select(selectLanguaje)
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.view.translations = this.i18nService.getTranslations(ComponentEnum.Dialog, lang);
      });
  }

  // Permite cerrar el modal si fue abierto por ModalController
  closeModal(role: string): void {
    try {
      this.modalCtrl.dismiss(undefined, role);
    } catch (e) {
      
    }
  }
}